import { useEffect, useState } from "react";
import { useGetFacultyByNameOrEmailQuery } from "../../../graphql/generated/graphql";
import SearchListModal from "../../../components/common/SearchListModal/SearchListModal";
import { CoursesTabModalState } from "./CoursesTabContainer";
import { useAppConfig } from "../../../AppConfigProvider";

const AssignFacultyToCourseListContainer = ({
  visible,
  onClose,
  onAction,
}: {
  visible: boolean;
  onClose: () => void;
  onAction: (id: string) => void;
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const appConfig = useAppConfig();
  const schoolId = appConfig.axioSchools[0];

  const { data: facultyData, refetch: facultyRefetch } = useGetFacultyByNameOrEmailQuery({
    variables: {
      nameOrEmail: searchQuery,
      schoolId,
      page: 1,
      pageSize: 5,
    },
  });

  useEffect(() => {
    facultyRefetch();
  }, [searchQuery]);

  const list =
    facultyData?.getFacultyByNameOrEmail?.data.faculties.map((faculty) => ({
      id: faculty.id,
      name: faculty.name,
    })) || [];

  return (
    <SearchListModal<CoursesTabModalState>
      visible={visible}
      onClose={onClose}
      onAction={onAction}
      list={list}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      modalType={CoursesTabModalState.ASSIGN_FACULTY}
    />
  );
};

export default AssignFacultyToCourseListContainer;
